import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const feeConfigSelector = ({ feeConfig }: ReducerState) => feeConfig;
export const feeConfigLoadingSelector = createSelector(
  feeConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
